
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/persona",
      function () {
        return require("private-next-pages/download/persona/index.tsx");
      }
    ]);
  